module.exports = __webpack_public_path__ + "static/media/AI-chatbot-logo.8498af7d.svg";